import { useQueryClient, useMutation } from 'react-query'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { type LegalPersonPersistence } from '../../../../types/persistence/legal-person-persistence'
import { api } from '../../../api'

async function updateExpertLegalData (
  id: number,
  data: LegalPersonPersistence
): Promise<ExpertDomain> {
  const response = await api.put<ExpertDomain>(`/experts/${id}/legal-data`, data)
  return response.data
}

export const useExpertLegalDataMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: LegalPersonPersistence }) {
      return updateExpertLegalData(id, data)
    },
    onSuccess (data) {
      queryClient.setQueryData(['expert', data.id], data)
    },
  })
}
